<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../component/common/Value/ArraySlotView.svelte";
    import SpaceSettingRowView from "./SpaceSettingRowView.svelte";
    import SpaceEditDialogView from "./SpaceEditDialogView.svelte";
    import AddButtonView from "../../../component/common/Button/AddButtonView.svelte";

    // export let params = null;
    let isLoading = false;

    let spaces = null;

    let editData = null;

    onMount(() => {
        loadData();
    });

    function loadData() {

        const paramMap = {};

        isLoading = true;
        const url = UrlUtil.createApiUrl("space", paramMap);
        const option = HttpRequestUtil.Option.createForGet();
        option.errorCallback = (response) => {
            isLoading = false;
        };

        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log("SpaceResourceView", response);
            const body = response['body'];

            spaces = body['spaces'];


        }, option);
    }

    function onClickAdd() {
        editData = {};
    }

    function onEdit(event) {
        const space = event.detail.space;
        editData = {...space};
    }

</script>

<div class="space-setting-page standard-page">
    <h1>Space設定</h1>

    <div class="space-area">
        <LoadingContentView isLoading={isLoading}>
            <ArraySlotView array={spaces}>
                <table>
                    <thead>
                    <tr>
                        <th></th>
                        <th>id</th>
                        <th>unique id</th>
                        <th>スペース名</th>
                        <th>説明</th>
                        <th>タイプ</th>
                        <th>Git Web Url</th>
                        <th>Git SSH Url</th>
                        <th>Slack投稿先</th>
                        <th></th>
                    </tr>

                    </thead>
                    <tbody>
                    {#each spaces as space}
                        <SpaceSettingRowView on:edit={onEdit} space={space}/>
                    {/each}
                    </tbody>
                </table>
                <div class="button-area">
                    <AddButtonView on:click={onClickAdd}/>
                </div>
            </ArraySlotView>
        </LoadingContentView>

    </div>


</div>

<SpaceEditDialogView
        editData={editData}
        on:close={()=>{
            editData = null;
        }}
        on:update={loadData}

/>

<style lang="scss">
    .space-setting-page {
        .space-area {
            .button-area {
                margin-top: 60px;
            }
        }
    }
</style>